<template>
  <section class="upload-container">
    <div class="upload-heading">
      <h3>{{ headingText || "Flexomask" }}</h3>
    </div>

    <!-- The body will serve as our actual drag and drop zone -->
    <div
      v-on:dragover.prevent="handleDragOver"
      v-on:drop.prevent="handleDrop"
      v-on:dragleave.prevent="handleDragLeave"
      class="upload-body"
      :class="{ 'upload-body-dragged': status.over }"
    >
      {{ bodyText || "Drop your PDF file here" }}
    </div>
  </section>
</template>

<script>
import store from "@/store/index.js"; // top level store object
// import axios from "axios"
import path from "path";
// import fs from "fs"
export default {
  // Accept the heading from parent component
  props: {
    heading: String,
  },

  data() {
    return {
      // Create a property that holds the file information
      file: {
        name: "",
        size: 0,
        value: "",
      },
      inputPdfFile: "",
      //Add Drag and drop status as an object
      status: {
        over: false,
        dropped: false,
      },
      headingText: "",
      bodyText: "",
      footerText: "",
      store,
    };
  },
  computed: {
    curfile() {
      return this.$store.state.curfile;
    },
    userinfo() {
      return this.$store.state.userinfo;
    },
    config() {
      return this.$store.state.config;
    },
  },
  methods: {
    handleDragOver() {
      this.status.over = true;
    },
    handleDrop() {
      this.status.dropped = true;
      this.status.over = false;
      this.file = "";
      //  clear out prev vals
      this.curfile.internamFn = "";
      this.curfile.fname = "";
      this.curfile.fext = "";
      this.curfile.sepnames = "";
      this.curfile.preview = "";
      this.curfile.status = "Ready to upload";
      this.curfile.phsize = "";
      this.curfile.pvsize = "";
      this.curfile.hsize = "";
      this.curfile.vsize = "";
      this.curfile.uom = "";
      this.curfile.plateCount = "";
      this.curfile.mediabox = "";
      this.curfile.artbox = "";
      this.curfile.pdfsepdefs = "";
      this.curfile.maskwidth = "";
      // end clear out
      this.inputPdfFile = event.dataTransfer.items[0].getAsFile();
      this.curfile.filehandle = this.inputPdfFile;
      this.file = {
        name: this.inputPdfFile.name,
        size: (this.inputPdfFile.size / 1024).toFixed(2),
        time: Date.now(),
      };
      this.curfile.fname = this.file.name.substring(
        0,
        this.file.name.length - 4
      );
      this.curfile.fext = this.file.name.substring(this.file.name.length - 4);
      this.curfile.fsize = this.file.size;
      this.curfile.inputPdfFile = this.inputPdfFile;
      // =====
      let reader = new FileReader();
      reader.readAsBinaryString(this.inputPdfFile);
      reader.onload = () => {
        // Things we need from the fileread function
        // osFilename.....: Check for chars outside of [a-Z,0-9, Space, Underscore, Dash]
        // Things we want to extract from the xmp data
        //
        // Thumbnail......: base64 encoded inline jpeg image
        // ThumbnailWidth.: width of preview in Pixels
        // ThumbnailHeight: height of preview in Pixels
        // Thformat.......: normally JPEG
        // Plates.........: Array["Black", "Magenta", "Cyan", "Yellow", "Spot_one"..."Spot_n"]
        // Page Dims......: Array[width, height, units]
        // PageCount.....: Check Number of Pages = 1
        // xmpFilename.......: Check for chars outside of [a-Z,0-9, Space, Underscore, Dash]
        // Colornts......: Only Pull definitions for plate colours used
        //
        // Things we pull from pdf stream
        // /MediaBox......: Array[four elements]
        // /ArtBox........: Array[four elements]
        // /LastModified..: date of form (D:YYYYMMDDHHMMSS-04'00')
        // Test to get xref table
        // let xref = pdfFile.match(/xref.*?(.*?)trailer/s)[1]
        let rawPdfFile = reader.result;
        // let localobj =''

        let pdfFile = rawPdfFile.match(/<x:xmpmeta.*?(.*?)<\/x:xmpmeta>/s)[1];

        //  Get xmp Thumbnail Info
        // if() {}

        let xmpThumbnailWidth = 200;
        if (pdfFile.match(/<xmpGImg:width>.*?(.*?)<\/xmpGImg:width>/s)) {
          xmpThumbnailWidth = pdfFile.match(
            /<xmpGImg:width>.*?(.*?)<\/xmpGImg:width>/s
          )[1];
        }

        if (pdfFile.match(/xmpGImg:width=.*/g)) {
          xmpThumbnailWidth = pdfFile.match(/xmpGImg:width="(.*)"/)[1];
        }

        // let xmpThumbnailWidth = pdfFile.match(
        //   /<xmpGImg:width>.*?(.*?)<\/xmpGImg:width>/s
        // )[1];

        let xmpThumbnailHeight = 200;
        if (pdfFile.match(/<xmpGImg:height>.*?(.*?)<\/xmpGImg:height>/s)) {
          xmpThumbnailHeight = pdfFile.match(
            /<xmpGImg:height>.*?(.*?)<\/xmpGImg:height>/s
          )[1];
        }

        // let xmpThumbnailFormat = pdfFile.match(
        // /<xmpGImg:format>.*?(.*?)<\/xmpGImg:format>/s
        // )[1]

        // Init with default pdf file icon data
        let xmpThumbnailImageRaw =
          "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";

        if (pdfFile.match(/<xmpGImg:image>.*?(.*?)<\/xmpGImg:image>/s)) {
          xmpThumbnailImageRaw = pdfFile.match(
            /<xmpGImg:image>.*?(.*?)<\/xmpGImg:image>/s
          )[1];
        }

        if (pdfFile.match(/xmpGImg:image=.*/g)) {
          xmpThumbnailImageRaw = pdfFile.match(/xmpGImg:image="(.*)"/)[1];
        }
        // let xmpThumbnailImageRaw = pdfFile.match(
        //   /<xmpGImg:image>.*?(.*?)<\/xmpGImg:image>/s
        // )[1];

        let temp = xmpThumbnailImageRaw.split("&#xA;");
        let xmpThumbnailImage = temp.join("");
        // cleanup unessecary vars
        xmpThumbnailImageRaw = temp = "";
        // end Get Thumbnail info

        // Get Plates Info
        // get PlateSeq XML from PlateNames element
        let platexmlSeq = pdfFile.match(
          /<xmpTPg:PlateNames>.*?(.*?)<\/xmpTPg:PlateNames>/s
        )[1];

        // get list items from PlateSeqence list element
        let platexmlli = platexmlSeq.match(/<rdf:Seq>.*?(.*?)<\/rdf:Seq>/s)[1];

        // make array of list elements
        let platestrings = platexmlli.match(/<rdf:li>.*?(.*?)<\/rdf:li>/g);

        // convert list items to array of strings
        let platearray = [];
        platestrings.forEach((element) => {
          platearray.push(element.match(/<rdf:li>.*?(.*?)<\/rdf:li>/s)[1]);
        });

        // cleanup unnecessary vars
        platexmlSeq = platexmlli = platestrings = "";

        //end get plates info

        // Get Page Dims

        let plateSizeStrings = "File";
        if (
          pdfFile.match(
            /<xmpTPg:MaxPageSize rdf:parseType="Resource">.*?(.*?)<\/xmpTPg:MaxPageSize>/s
          )
        ) {
          plateSizeStrings = pdfFile.match(
            /<xmpTPg:MaxPageSize rdf:parseType="Resource">.*?(.*?)<\/xmpTPg:MaxPageSize>/s
          )[1];
        }

        // let plateSizeStrings = pdfFile.match(
        //   /<xmpTPg:MaxPageSize rdf:parseType="Resource">.*?(.*?)<\/xmpTPg:MaxPageSize>/s
        // )[1];

        // Get height width and units
        let plateWidth = 0;
        if (plateSizeStrings.match(/<stDim:w>.*?(.*?)<\/stDim:w>/s)) {
          plateWidth = plateSizeStrings.match(
            /<stDim:w>.*?(.*?)<\/stDim:w>/s
          )[1];
        }

        if (pdfFile.match(/stDim:w="(.*)"/g)) {
          plateWidth = pdfFile.match(/stDim:w="(.*)"/)[1];
        }

        let plateHeight = 0;
        if (plateSizeStrings.match(/<stDim:h>.*?(.*?)<\/stDim:h>/s)) {
          plateHeight = plateSizeStrings.match(
            /<stDim:h>.*?(.*?)<\/stDim:h>/s
          )[1];
        }

        if (pdfFile.match(/stDim:h="(.*)"/g)) {
          plateHeight = pdfFile.match(/stDim:h="(.*)"/)[1];
        }

        // let plateHeight = plateSizeStrings.match(
        //   /<stDim:h>.*?(.*?)<\/stDim:h>/s
        // )[1];

        let plateUnits = "xx File";
        if (plateSizeStrings.match(/<stDim:unit>.*?(.*?)<\/stDim:unit>/s)) {
          plateUnits = plateSizeStrings.match(
            /<stDim:unit>.*?(.*?)<\/stDim:unit>/s
          )[1];
        }

        if (pdfFile.match(/stDim:unit="(.*)"/g)) {
          plateUnits = pdfFile.match(/stDim:unit="(.*)"/)[1];
        }

        // let plateUnits = plateSizeStrings.match(
        //   /<stDim:unit>.*?(.*?)<\/stDim:unit>/s
        // )[1];

        // end get height width and units

        // Get Number of Pages
        let plateCount = 1;
        if (pdfFile.match(/<xmpTPg:NPages>.*?(.*?)<\/xmpTPg:NPages>/s)) {
          plateCount = pdfFile.match(
            /<xmpTPg:NPages>.*?(.*?)<\/xmpTPg:NPages>/s
          )[1];
        }

        // let plateCount = pdfFile.match(
        //   /<xmpTPg:NPages>.*?(.*?)<\/xmpTPg:NPages>/s
        // )[1];

        // Get internalFileName
        let intFilenameAlt = pdfFile.match(
          /<dc:title>.*?(.*?)<\/dc:title>/s
        )[1];
        let intFilenameli = intFilenameAlt.match(
          /<rdf:Alt>.*?(.*?)<\/rdf:Alt>/s
        )[1];
        let internamFn = intFilenameli.match(
          /<rdf:li xml:lang="x-default">.*?(.*?)<\/rdf:li>/s
        )[1];

        // cleanup unnecessary vars
        intFilenameAlt = intFilenameli = "";

        // End Get internalFilename

        // Get Colourants <xmpG:Colorants>
        let xmpSwatchGroup = "";
        if (pdfFile.match(/<xmpG:Colorants>.*?(.*?)<\/xmpG:Colorants>/s)) {
          xmpSwatchGroup = pdfFile.match(
            /<xmpG:Colorants>.*?(.*?)<\/xmpG:Colorants>/s
          )[1];
        }

        // Get /Artbox......: Array[four elements]
        let artboxstring = rawPdfFile.match(/\/ArtBox\[.*?(.*?)\]/s)[1];
        let artbox = artboxstring.split(" ");
        // clean up artboxstring
        artboxstring = "";

        // Get /Mediabox......: Array[four elements]
        let mediatboxstring = rawPdfFile.match(/\/MediaBox\[.*?(.*?)\]/s)[1];
        let mediabox = mediatboxstring.split(" ");

        // clean up mediatboxstring
        mediatboxstring = "";
        // Assign Values to localobj store (need to refactor to use mutations)
        this.curfile.internamFn = internamFn;
        this.curfile.sepnames = platearray;
        this.curfile.swatchgroup = xmpSwatchGroup;
        this.curfile.preview = xmpThumbnailImage;
        this.curfile.phsize = xmpThumbnailWidth;
        this.curfile.pvsize = xmpThumbnailHeight;
        this.curfile.hsize = plateWidth;
        this.curfile.vsize = plateHeight;
        this.curfile.uom = plateUnits;
        this.curfile.plateCount = plateCount;
        this.curfile.mediabox = mediabox;
        this.curfile.artbox = artbox;
        this.curfile.pdfsepdefs = "";
        this.curfile.maskwidth = 500;

        // create check uri
        this.curfile.chks3uri =
          "s3://" +
          path.join(
            this.config.uploads3,
            this.userinfo.co.replace(/[^a-z0-9.]/gi, "_"),
            this.userinfo.site.replace(/[^a-z0-9.]/gi, "_"),
            this.userinfo.uemail.replace(/[^a-z0-9.]/gi, "_"),
            this.curfile.fname.replace(/[^a-z0-9.]/gi, "_") + this.curfile.fext
          );

        // create check jtchks3uri
        this.curfile.jtchks3uri =
          "s3://" +
          path.join(
            this.config.uploads3,
            this.userinfo.co.replace(/[^a-z0-9.]/gi, "_"),
            this.userinfo.site.replace(/[^a-z0-9.]/gi, "_"),
            this.userinfo.uemail.replace(/[^a-z0-9.]/gi, "_"),
            this.curfile.fname.replace(/[^a-z0-9.]/gi, "_") + ".json"
          );
      };
    },
    handleDragLeave() {
      this.status.over = false;
    },
  }, // end of methods
};
</script>

<style scoped>
/* Add basic styles for the upload container */

.upload-container {
  border-radius: 0.25rem;
  display: flexbox;
  /* border: 1px solid#464943; */
  box-shadow: 0rem 0.1rem 0.1rem 0.1rem rgb(184, 182, 182);
  /* display: block; */
  margin: auto;
  width: 53rem;
  min-width: 45rem;
  /* min-height: 50vh; */
  height: 31rem;
  padding: 5rem;
  background-color: rgb(210, 210, 210);
}

.upload-heading,
.upload-footer {
  background: #ccc;
  color: rgb(85, 76, 76);
  padding: 1rem 1rem;
  font-weight: 600;
  display: none;
}

.upload-body {
  align-items: center;
  background-color: rgb(210, 210, 210);
  color: #486684;
  display: flex;
  font-size: 1.5rem;
  justify-content: center;
  height: 31rem;
}

.upload-body-dragged {
  color: #fff;
  background-color: #89bb89;
}
</style>
